import { usePropertyRoles } from '@/hooks/usePropertyRoles.ts';

export const useComposerUploadCapabilities = () => {
	const { isOwner } = usePropertyRoles();

	return {
		canUseEmailUpload: isOwner,
	} as const;
};
